import React, { useEffect, useState } from 'react'
import styles from './Questions.module.scss'
import Button from '../../../partials/Button'
import Question from '../../../partials/Questions/Question'
import FeedbackBlock from '../../../partials/FeedbackBlock';
import Modal from "../../../partials/Modal/SimpleModal/SimpleModal"
import HTMLContent from '../../../partials/HTMLContent';
import Scroll from '../../../partials/Scroll/Scroll';

const Questions = ({ data, next, onComplete, globals }) => {

    const [currentQuestion, setCurrentQuestion] = useState();
    const [currentIndex, setCurrentIndex] = useState(0);
    const [completed, setCompleted] = useState(false);
    const [answersFeedback, setAnswersFeedback] = useState();
    const [showFeedback, setShowFeedback] = useState();

  
    useEffect(() => {
      if(currentIndex > -1 && currentIndex < data.questions.length) {
        setCurrentQuestion(data.questions[currentIndex])
      }
    }, [currentIndex])

    useEffect(()=>{

      if(next) {
        setAnswersFeedback()
        onContinueHandle()
      }
      
    }, [next])
    
    const handleNextQuestion = () => {
      onContinueHandle()
      setShowFeedback(false)
    }

    const handleRetryQuestion = () => {
        setCurrentQuestion({...currentQuestion, rand: Math.random()})
        setShowFeedback(false)
    }

    const handleAnswers = (feedback) => {
          
      setAnswersFeedback(feedback)
      setShowFeedback({
          status: feedback.status,
          caption: feedback.status === 'failed' && !feedback.correct ? globals?.feedbackHeaderFailed : 
                   feedback.correct ? globals?.feedbackHeaderSuccess : globals?.feedbackHeaderWarning,
      })

    }
    
    const onContinueHandle = () => {
      
      if(currentIndex + 1 >= data.questions.length) {
        setCompleted(true)
        onComplete()
      } else {
        setCurrentIndex( currentIndex + 1 );
      }
    }

    const displayFeedback = (question) => {

      if(question.feedback){
        return <HTMLContent html={question.feedback[question.status]} />
      }
      else{
        
        const html = question.answers.map((answer, index)=>{

          return (
              <div key={index}>
                  <h3>{answer.option} </h3>
                  <p >
                      {answer.feedback}
                  </p>
                  
              </div>
          )
        })

        return <HTMLContent >{html}</HTMLContent>
      }

    }
    return (
        <div className={styles.container} >
          <>
  
              { currentQuestion &&
                <>

                  <Question 
                    data={currentQuestion}
                    feedback={handleAnswers}
                    showSubmit={!completed}
                    locked={!completed}
                  />
                  
                </>
              }
          </>

          { showFeedback &&  
                <Modal 
                    size="small" 
                    show={showFeedback} 
                    scroll={false}
                  >
                    <FeedbackBlock 
                        variant="fill"
                        status={showFeedback ? showFeedback.status : false }
                        caption={showFeedback ? showFeedback.caption : false } 
                        className={styles.feedback_content}
                    >
                      <Scroll>
                        <div className='feedback-wrapper'>
                            { displayFeedback(answersFeedback) }
                            
                            { showFeedback.status !=="failed" &&
                                <Button text="Next" onClick={ handleNextQuestion } /> 
                            }
                            { showFeedback.status ==="failed" &&
                                <Button text="Retry" onClick={ handleRetryQuestion } /> 
                            }
                        </div>
                      </Scroll>
                    </FeedbackBlock>
                </Modal>
            }
        </div>
    )
}


export default Questions